import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { CustomIcon, CustomIconSet, ConfirmModalWindow, LoadingPane } from '@social-solutions/ssg-forms';
import ScheduleHeaderComponent from '../scheduleHeader/scheduleHeader.component';
import * as appointmentDetailsActions from './appointmentDetails.actions';
import * as authActions from '../../auth/auth.actions';
import './details.scss';
import moment from 'moment';

/** displays the details of a selected appointment */
class AppointmentDetailsComponent extends Component {

  componentDidMount() {
    const { appointmentDetailsActions } = this.props;
    const url = window.location.pathname.split('/');
    const urlId = parseInt(url.pop(), 10);
    appointmentDetailsActions.fetchAppointment(urlId);
  }

  showCancelModal = () => {
    const { appointmentDetailsActions } = this.props;
    appointmentDetailsActions.showCancelModal();
  }

  handleClose = (_, confirmed) => {
    const { appointmentDetails: { appointment: { creationUserId } }, appointmentDetailsActions } = this.props;

    if (confirmed) {
      const url = window.location.pathname.split('/');
      const urlId = parseInt(url.pop(), 10);
      appointmentDetailsActions.cancelAppointment(urlId, creationUserId);
    }
    appointmentDetailsActions.hideCancelModal();
  }

  returnToAppointmentList = () => {
    const { redirectTo } = this.props;
    redirectTo('/appointments');
  }

  render() {
    const {
      appointmentDetails: {
        appointment: { id, title, startTime, endTime, location, description, staffInvitees, subjectInvitees },
        fetch,
        showCancelModal,
        returnToAppointments,
      },
      appointmentDetailsActions: { finishRedirect },
    } = this.props;

    if (returnToAppointments) {
      finishRedirect();
      this.returnToAppointmentList();
    }

    const url = window.location.pathname.split('/');
    const urlId = parseInt(url.pop(), 10);

    const modalText = 'If you click continue, this appointment will be cancelled and removed.';

    return (
      <div>
        {showCancelModal ? <ConfirmModalWindow
          id="cancel-appointment"
          title='Are you sure?'
          overrideShow={true}
          hideCloseButton={true}
          onClose={this.handleClose}
          yesButtonText={'Continue'}
          noButtonText={'Cancel'}
        >
          {modalText}
        </ConfirmModalWindow> : undefined}
        <div>
          <ScheduleHeaderComponent location={'/appointments'} />
          <LoadingPane loadingMessage="Loading Appointment" loadingState={{ isLoading: fetch.isFetching, data: fetch.data, error: fetch.error }}>
            {!fetch.isFetching ? (
              urlId === id ? (
                <div className="details-container">
                  <span className='details-header'>
                    <button
                      id='closeDetailsButton'
                      className='ssg-forms-icon-btn message-dismiss-btn'
                      title="Dismiss"
                      aria-label={'dismiss'}
                      onClick={this.returnToAppointmentList}>
                      <CustomIcon iconChoice={CustomIconSet.ic_x_14x14} />
                    </button>
                    <div className="title">{title}</div>
                  </span>
                  <span className="time-frame">
                    <div>{moment(startTime).format('LL')}</div>
                    <div>{moment(startTime).format('LT')} - {moment(endTime).format('LT')}</div>
                  </span>
                  <div className="attendees details-label">ATTENDEES</div>
                  <ul>
                    {[...staffInvitees, ...subjectInvitees].map(a => <li key={a.email + a.name}>{a.name}</li>)}
                  </ul>

                  {location ? (<div><div className=" details-label">LOCATION</div><p id="location-circle" className="ssg-forms-btn ssg-forms-btn-secondary">{location}</p></div>) : undefined}
                  <div className="details-label">DESCRIPTION</div><p>{description}</p>
                  <button id="cancel-appointment-btn" className="ssg-forms-btn ssg-forms-btn-secondary" onClick={this.showCancelModal}>Cancel Appointment</button>
                </div>
              ) : (<div><ScheduleHeaderComponent location={'/appointments'} /><div>No Appointment Found</div></div>)
            ) : null}
          </LoadingPane>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth, appointmentDetails }) => {
  return {
    auth,
    appointmentDetails,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectTo: bindActionCreators(push, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
    appointmentDetailsActions: bindActionCreators(appointmentDetailsActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDetailsComponent);



// WEBPACK FOOTER //
// src/scheduler/appointmentDetails/appointmentDetails.component.js